import React, { Component } from 'react'
import { connect } from 'react-redux';
import withAppShell from '../../../hoc/withAppShell/WithAppShell';
import { gradePickerUtil } from '../../gradePicker';
import { RulesComponent } from '.';
import { toast } from 'react-toastify'
import lodashUtil from 'lodash'
import { SchoolInformationActions } from '../../../../store';
import theme from '../../../../assests/theme';
import * as Constants from '../../../../constants';
class RulesContainer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			gradeString: 'FILTER BY GRADES',
			openForFilterRules: false,

		}
	}

	componentWillMount() {
		const i18n = this.props.i18n
		if (this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].weeklyCalendar[0] === undefined) {
			toast(i18n.toastMsgs.noDataInWeeklyCalendar)
			this.props.previousStep()
		} else {
			let activeSchool = this.props.activeSchool;
			let gradeLevels = activeSchool.school_master.gradeLevels;
			let subjects = activeSchool.school_master.subjects;
			let electives = activeSchool.school_master.electives;
			let weeklyCalendar = activeSchool.schedule_constraints[this.props.activeScheduleIndex].weeklyCalendar[0]
			let gradeDetails = undefined;
			if (weeklyCalendar !== undefined) {
				gradeDetails = weeklyCalendar.gradeDetails
			} else {
				gradeDetails = {
					allGrades: true
				}
			}
			let filter = {
				gradeDetails: gradeDetails,
				showSections: false,
				showAllSubjects: false,
			}

			let gradesMap = this.getGradesMap(gradeLevels, filter);
			let subjectsMap = this.getSubjectsMap(subjects);
			let electivesMap = this.getElectivesMap(electives)
			let subjectsAndElectivesMap = this.getSubjectsAndElectivesMap(subjects, electives, filter);
			let subjectsAndElectivesMapSize = subjectsAndElectivesMap.size;
			let dataTableMap = this.getDataTableMap(gradesMap, subjectsAndElectivesMap, electivesMap, subjects, electives, gradeLevels, filter);
			let subjectMapSize = subjectsMap.size;
			let gradesMapSize = gradesMap.size;

			this.setState({
				activeSchool: activeSchool,
				gradesMap: gradesMap,
				subjectsMap: subjectsMap,
				subjectMapSize: subjectMapSize,
				gradesMapSize: gradesMapSize,
				masterGradeLevels: gradeLevels,
				subjects: subjects,
				electives: electives,
				dataTableMap: dataTableMap,
				filter: filter,
				subjectsAndElectivesMap: subjectsAndElectivesMap,
				subjectsAndElectivesMapSize: subjectsAndElectivesMapSize,
				weeklyCalendar: weeklyCalendar
			})
			dataTableMap = this.getJointClassMap(dataTableMap, subjects, filter);
			this.generateDataTableMap(dataTableMap, filter);
		}
	}

	generateDataTableMap = (dataTableMap, filter) => {
		let t1 = new Date();
		// assign all the constraints from the activeSchool to state and pass one by one to construct "data table map"  

		let numberOfTeachersAndTAsForSubjects = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForSubjects;
		dataTableMap = this.getConstraintDetails(dataTableMap, filter, numberOfTeachersAndTAsForSubjects, "numberOfTeachersAndTAsForSubject");

		let numberOfTeachersAndTAsForElectives = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForElectives;
		dataTableMap = this.getConstraintDetails(dataTableMap, filter, numberOfTeachersAndTAsForElectives, "numberOfTeachersAndTAsForElective");

		let fixedTeachersAndTAsForSubjects = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForSubjects;
		dataTableMap = this.getConstraintDetails(dataTableMap, filter, fixedTeachersAndTAsForSubjects, "fixedTeachersAndTAsForSubject");

		let fixedTeachersAndTAsForElectives = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].fixedTeachersAndTAsForElectives;
		dataTableMap = this.getConstraintDetails(dataTableMap, filter, fixedTeachersAndTAsForElectives, "fixedTeachersAndTAsForElective");

		let multiPeriods = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].multiPeriods;
		dataTableMap = this.getConstraintDetails(dataTableMap, filter, multiPeriods, "multiPeriod");

		let preferredPeriods = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].preferredPeriods
		dataTableMap = this.getConstraintDetails(dataTableMap, filter, preferredPeriods, "preferredPeriod");

		let sharedRoomsForSubjects = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForSubjects
		dataTableMap = this.getConstraintDetails(dataTableMap, filter, sharedRoomsForSubjects, "sharedRoomsForSubject");

		let sharedRoomsForElectives = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForElectives
		dataTableMap = this.getConstraintDetails(dataTableMap, filter, sharedRoomsForElectives, "sharedRoomsForElective");

		let totalPeriods = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].totalPeriods
		dataTableMap = this.getConstraintDetails(dataTableMap, filter, totalPeriods, "totalPeriod");

		let jointClasses = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses
		dataTableMap = this.getConstraintDetails(dataTableMap, filter, jointClasses, "jointClass");

		let t2 = new Date();
		let t3 = t2 - t1;
		this.setState({ dataTableMap: dataTableMap })
	}

	getGradesMap = (mastergradeLevels, filter) => {
		let gradesMap = new Map();
		let gradeLevels = gradePickerUtil.constructGradeLevelJSON({ gradeLevels: mastergradeLevels }, filter.gradeDetails);
		let columnCount = 0;
		if (filter.showSections) {
			if (gradeLevels.isAllChecked) {
				for (let i = 0; i < gradeLevels.gradeLevels.length; i++) {
					for (let j = 0; j < gradeLevels.gradeLevels[i].grades.length; j++) {
						for (let k = 0; k < gradeLevels.gradeLevels[i].grades[j].groups.length; k++) {
							gradesMap.set(gradeLevels.gradeLevels[i].grades[j].gradeName + "-" + gradeLevels.gradeLevels[i].grades[j].groups[k].groupName, columnCount++);
						}
					}
				}
			} else if (gradeLevels.indeterminate) {
				for (let gradeLevelIndex = 0; gradeLevelIndex < gradeLevels.gradeLevels.length; gradeLevelIndex++) {
					if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelSelected) {
						for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
							for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
								gradesMap.set(gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName + "-" + gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName, columnCount++);
							}
						}
					} else if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelIntermediate) {
						for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
							if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].isGradeSelected) {
								for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
									gradesMap.set(gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName + "-" + gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName, columnCount++);
								}
							} else {
								for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
									if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].isGroupSelected) {
										gradesMap.set(gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName + "-" + gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName, columnCount++);

									}
								}
							}
						}
					}

				}
			}
		} else {
			if (gradeLevels.isAllChecked) {
				for (let i = 0; i < gradeLevels.gradeLevels.length; i++) {
					for (let j = 0; j < gradeLevels.gradeLevels[i].grades.length; j++) {
						gradesMap.set(gradeLevels.gradeLevels[i].grades[j].gradeName, columnCount++);
					}
				}
			} else if (gradeLevels.indeterminate) {
				for (let gradeLevelIndex = 0; gradeLevelIndex < gradeLevels.gradeLevels.length; gradeLevelIndex++) {
					if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelSelected) {
						for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
							gradesMap.set(gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName, columnCount++);
						}
					} else if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelIntermediate) {
						for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
							if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].isGradeSelected) {
								gradesMap.set(gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName, columnCount++);
							} else {
								for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
									if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].isGroupSelected) {
										gradesMap.set(gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName, columnCount++);
									}
								}
							}
						}
					}

				}
			}
		}
		return gradesMap;
	}

	getSubjectsMap = (subjectsJson, filter) => {
		let subjectsMap = new Map();
		if (filter === undefined) {
			for (let i = 0; i < subjectsJson.length; i++) {
				subjectsMap.set(subjectsJson[i].name, i)
			}
		} else {

		}
		return subjectsMap;
	}

	getElectivesMap = (electivesJson) => {
		let electivesMap = new Map();
		for (let i = 0; i < electivesJson.length; i++) {
			electivesMap.set(electivesJson[i].name, i)
		}
		return electivesMap;
	}

	getSubjectsAndElectivesMap = (subjectsJson, electivesJson, filter) => {
		let subjectsAndElectivesMap = new Map();
		let count = -1;
		let i = undefined;
		if (filter.showAllSubjects || filter.gradeDetails.allGrades) {
			for (i = 0; i < subjectsJson.length; i++) {
				subjectsAndElectivesMap.set(subjectsJson[i].name, i)
			}
			for (i = 0; i < electivesJson.length; i++) {
				subjectsAndElectivesMap.set(electivesJson[i].name, subjectsJson.length + i)
			}
		}
		// if showAllSubjects is FALSE 
		else {
			// if all grades is TRUE in filter gradeDetails then? we should do a validation in subjects not allowing him to add a subject with empty gradeDetails
			if (filter.gradeDetails.gradeLevels !== undefined) {

				//SUBJECTS 
				for (i = 0; i < subjectsJson.length; i++) {
					if (subjectsJson[i].gradeDetails.allGrades === true) {
						count++;
						subjectsAndElectivesMap.set(subjectsJson[i].name, count);
						continue
					}
					let filter_gradeLevel = filter.gradeDetails.gradeLevels;

					if (filter_gradeLevel.length > 0) {
						let subject_gradeLevels = subjectsJson[i].gradeDetails.gradeLevels;
						let isGradeLevelPresent = lodashUtil.differenceBy(filter_gradeLevel, subject_gradeLevels, 'level');
						if (isGradeLevelPresent.length !== filter_gradeLevel.length) {
							count++
							subjectsAndElectivesMap.set(subjectsJson[i].name, count);
						} else {
							// write if the grade levels dosent match then take the master grades for the particular level and then compare the grades in the subjects 
							//check if filter's gradeLevel and subject's grade 
							let gradeLevels = this.props.activeSchool.school_master.gradeLevels
							let subjectPushed = false;
							for (let g = 0; g < filter_gradeLevel.length; g++) {
								for (let h = 0; h < subjectsJson[i].gradeDetails.grades.length; h++) {
									let levelName = filter_gradeLevel[g].level;
									let level = lodashUtil.find(gradeLevels, ['levelName', levelName]) // getting the level from the master which exists in the filter.
									let gradeName = subjectsJson[i].gradeDetails.grades[h].grade
									let isGradePresent = level !== undefined ? lodashUtil.find(level.grades, ['gradeName', gradeName]) : undefined;
									if (isGradePresent !== undefined) {
										count++
										subjectsAndElectivesMap.set(subjectsJson[i].name, count);
										subjectPushed = true;
										break;
									}
								}
								if (subjectPushed === true) {
									break;
								}
							}
						}
					}

					// if subject's gradeLevels are present and we check with filter's grades
					if (subjectsJson[i].gradeDetails.gradeLevels.length > 0) {
						let subject_gradeLevels = subjectsJson[i].gradeDetails.gradeLevels
						let filter_grades = filter.gradeDetails.grades;
						let gradeLevels = this.props.activeSchool.school_master.gradeLevels;
						let subjectPushed = false;
						for (let a = 0; a < subject_gradeLevels.length; a++) {
							for (let b = 0; b < filter_grades.length; b++) {
								let levelName = subject_gradeLevels[a].level;
								let level = lodashUtil.find(gradeLevels, ['levelName', levelName]);
								let gradeName = filter_grades[b].grade;
								let isGradePresent = lodashUtil.find(level.grades, ['gradeName', gradeName]);
								if (isGradePresent !== undefined) {
									count++
									subjectsAndElectivesMap.set(subjectsJson[i].name, count);
									subjectPushed = true;
									break;
								}
							}
							if (subjectPushed === true) {
								break;
							}

						}
					}

					// if grade LEVELS array is empty then compare grades in filter
					let filter_grades = filter.gradeDetails.grades;
					if (filter_grades.length > 0) {
						let subject_grades = subjectsJson[i].gradeDetails.grades;
						let isGradesPresent = lodashUtil.differenceBy(filter_grades, subject_grades, 'grade')
						if (isGradesPresent.length !== filter_grades.length) {
							count++
							subjectsAndElectivesMap.set(subjectsJson[i].name, count);
						}
					}
				}


				//EELCTIVES 
				for (i = 0; i < electivesJson.length; i++) {
					if (electivesJson[i].gradeDetails.allGrades === true) {
						count++;
						subjectsAndElectivesMap.set(electivesJson[i].name, count)
						continue
					}
					let filter_gradeLevel = filter.gradeDetails.gradeLevels;

					if (filter_gradeLevel.length !== 0) {
						let elective_gradeLevels = electivesJson[i].gradeDetails.gradeLevels;
						let isGradeLevelPresent = lodashUtil.differenceBy(filter_gradeLevel, elective_gradeLevels, 'level');
						if (isGradeLevelPresent.length !== filter_gradeLevel.length) {
							count++;
							subjectsAndElectivesMap.set(electivesJson[i].name, count);
						} else {
							// write if the grade levels dosent match then take the master grades for the particular level and then compare the grades in the subjects 
							let gradeLevels = this.props.activeSchool.school_master.gradeLevels
							let subjectPushed = false;
							for (let g = 0; g < filter_gradeLevel.length; g++) {
								for (let h = 0; h < electivesJson[i].gradeDetails.grades.length; h++) {
									let levelName = filter_gradeLevel[g].level;
									let level = lodashUtil.find(gradeLevels, ['levelName', levelName])
									let gradeName = electivesJson[i].gradeDetails.grades[h].grade
									let isGradePresent = lodashUtil.find(level.grades, ['gradeName', gradeName]);
									if (isGradePresent !== undefined) {
										count++
										subjectsAndElectivesMap.set(electivesJson[i].name, count);
										subjectPushed = true;
										break;
									}
								}
								if (subjectPushed === true) {
									break;
								}
							}
						}
					}

					// if elective's gradeLevels are present and we check with filter's grades
					if (electivesJson[i].gradeDetails.gradeLevels.length > 0) {
						let elective_gradeLevels = electivesJson[i].gradeDetails.gradeLevels
						let filter_grades = filter.gradeDetails.grades;
						let gradeLevels = this.props.activeSchool.school_master.gradeLevels;
						let subjectPushed = false;
						for (let a = 0; a < elective_gradeLevels.length; a++) {
							for (let b = 0; b < filter_grades.length; b++) {
								let levelName = elective_gradeLevels[a].level;
								let level = lodashUtil.find(gradeLevels, ['levelName', levelName]);
								let gradeName = filter_grades[b].grade;
								let isGradePresent = lodashUtil.find(level.grades, ['gradeName', gradeName]);
								if (isGradePresent !== undefined) {
									count++
									subjectsAndElectivesMap.set(electivesJson[i].name, count);
									subjectPushed = true;
									break;
								}
							}
							if (subjectPushed === true) {
								break;
							}

						}
					}

					// if grade LEVELS array is empty then compare grades in filter
					let filter_grades = filter.gradeDetails.grades;
					if (filter_grades.length > 0) {
						let filter_grades = filter.gradeDetails.grades;
						let elective_grades = electivesJson[i].gradeDetails.grades;
						let isGradesPresent = lodashUtil.differenceBy(filter_grades, elective_grades, 'grade')
						if (isGradesPresent.length !== filter_grades.length) {
							count++;
							subjectsAndElectivesMap.set(electivesJson[i].name, count);
						}
					}
				}
			}
		}
		return subjectsAndElectivesMap;
	}

	getDataTableMap = (gradesMap, subjectsAndElectivesMap, electivesMap, subjects, electives, mastergradeLevels, filter, getEctivesDataTable) => {
		let subjectDataTableMap = new Map();
		//let rowIndex = undefined;
		for (let subjectIndex = 0; subjectIndex < subjects.length; subjectIndex++) {
			let rowIndex = subjectsAndElectivesMap.get(subjects[subjectIndex].name)
			let gradeLevels = gradePickerUtil.constructGradeLevelJSON({ gradeLevels: mastergradeLevels }, subjects[subjectIndex].gradeDetails);
			if (filter.showSections) {
				if (gradeLevels.isAllChecked) {
					for (let i = 0; i < gradeLevels.gradeLevels.length; i++) {
						for (let j = 0; j < gradeLevels.gradeLevels[i].grades.length; j++) {
							for (let k = 0; k < gradeLevels.gradeLevels[i].grades[j].groups.length; k++) {
								let columnIndex = gradesMap.get(gradeLevels.gradeLevels[i].grades[j].gradeName + "-" + gradeLevels.gradeLevels[i].grades[j].groups[k].groupName)
								if (columnIndex !== undefined) {
									subjectDataTableMap.set(rowIndex + "-" + columnIndex, { subject: subjects[subjectIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[i].levelName, grade: gradeLevels.gradeLevels[i].grades[j].gradeName, group: gradeLevels.gradeLevels[i].grades[j].groups[k].groupName })
								}
							}
						}
					}
				} else if (gradeLevels.indeterminate) {
					for (let gradeLevelIndex = 0; gradeLevelIndex < gradeLevels.gradeLevels.length; gradeLevelIndex++) {
						if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelSelected) {
							for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
								for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
									let columnIndex = gradesMap.get(gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName + "-" + gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName)
									if (columnIndex !== undefined) {
										subjectDataTableMap.set(rowIndex + "-" + columnIndex, { subject: subjects[subjectIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[gradeLevelIndex].levelName, grade: gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName, group: gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName })
									}
								}
							}
						} else if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelIntermediate) {
							for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
								if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].isGradeSelected) {
									for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
										let columnIndex = gradesMap.get(gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName + "-" + gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName)
										if (columnIndex !== undefined) {
											subjectDataTableMap.set(rowIndex + "-" + columnIndex, { subject: subjects[subjectIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[gradeLevelIndex].levelName, grade: gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName, group: gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName })
										}
									}
								} else {
									for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
										if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].isGroupSelected) {
											let columnIndex = gradesMap.get(gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName + "-" + gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName)
											if (columnIndex !== undefined) {
												subjectDataTableMap.set(rowIndex + "-" + columnIndex, { subject: subjects[subjectIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[gradeLevelIndex].levelName, grade: gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName, group: gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName })
											}
										}
									}
								}
							}
						}

					}
				}
			} else {
				if (gradeLevels.isAllChecked) {
					// for (let [key, columnIndex] of gradesMap) {
					//   dataTableMap.set(rowIndex + "-" + columnIndex, { subject: subjects[i], isSelected: false, border: '' })
					// }
					for (let i = 0; i < gradeLevels.gradeLevels.length; i++) {
						for (let j = 0; j < gradeLevels.gradeLevels[i].grades.length; j++) {
							let columnIndex = gradesMap.get(gradeLevels.gradeLevels[i].grades[j].gradeName)
							if (columnIndex !== undefined) {
								subjectDataTableMap.set(rowIndex + "-" + columnIndex, { subject: subjects[subjectIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[i].levelName, grade: gradeLevels.gradeLevels[i].grades[j].gradeName })
							}
						}
					}
				} else if (gradeLevels.indeterminate) {
					for (let gradeLevelIndex = 0; gradeLevelIndex < gradeLevels.gradeLevels.length; gradeLevelIndex++) {
						if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelSelected) {
							for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
								let columnIndex = gradesMap.get(gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName)
								if (columnIndex !== undefined) {
									subjectDataTableMap.set(rowIndex + "-" + columnIndex, { subject: subjects[subjectIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[gradeLevelIndex].levelName, grade: gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName })
								}
							}
						} else if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelIntermediate) {
							for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
								if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].isGradeSelected) {
									for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
										let columnIndex = gradesMap.get(gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName)
										if (columnIndex !== undefined) {
											subjectDataTableMap.set(rowIndex + "-" + columnIndex, { subject: subjects[subjectIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[gradeLevelIndex].levelName, grade: gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName })
										}
									}
								} else {
									// for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
									// 	if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].isGroupSelected) {
									// 		let columnIndex = gradesMap.get(gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName)
									// 		if (columnIndex !== undefined) {
									// 			//subjectDataTableMap.set(rowIndex + "-" + columnIndex, { subject: subjects[subjectIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[gradeLevelIndex].levelName, grade: gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName })
									// 		}
									// 	}
									// }
								}
							}
						}

					}
				}
			}
		}
		let electivesDataTableMap = this.getEctivesDataTable(gradesMap, subjectsAndElectivesMap, electives, mastergradeLevels, filter, subjectDataTableMap);
		// let  dataTableMap = new Map([...subjectDataTableMap, ...electivesDataTableMap])
		return subjectDataTableMap;
	}

	getEctivesDataTable = (gradesMap, electivesMap, electives, mastergradeLevels, filter, subjectDataTableMap) => {
		let dataTableMap = subjectDataTableMap;
		for (let electiveIndex = 0; electiveIndex < electives.length; electiveIndex++) {
			let rowIndex = electivesMap.get(electives[electiveIndex].name);
			let gradeLevels = gradePickerUtil.constructGradeLevelJSON({ gradeLevels: mastergradeLevels }, electives[electiveIndex].gradeDetails);
			if (filter.showSections) {
				if (gradeLevels.isAllChecked) {
					for (let a = 0; a < gradeLevels.gradeLevels.length; a++) {
						for (let b = 0; b < gradeLevels.gradeLevels[a].grades.length; b++) {
							for (let c = 0; c < gradeLevels.gradeLevels[a].grades[b].groups.length; c++) {
								let columnIndex = gradesMap.get(gradeLevels.gradeLevels[a].grades[b].gradeName + "-" + gradeLevels.gradeLevels[a].grades[b].groups[c].groupName)
								if (columnIndex !== undefined) {
									dataTableMap.set(rowIndex + "-" + columnIndex, { elective: electives[electiveIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[a].levelName, grade: gradeLevels.gradeLevels[a].grades[b].gradeName, group: gradeLevels.gradeLevels[a].grades[b].groups[c].groupName })
								}
							}
						}
					}
				} else if (gradeLevels.indeterminate) {
					for (let _gradeLevelIndex = 0; _gradeLevelIndex < gradeLevels.gradeLevels.length; _gradeLevelIndex++) {
						if (gradeLevels.gradeLevels[_gradeLevelIndex].isGradeLevelSelected) {
							for (let _gradeIndex = 0; _gradeIndex < gradeLevels.gradeLevels[_gradeLevelIndex].grades.length; _gradeIndex++) {
								for (let _groupIndex = 0; _groupIndex < gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].groups.length; _groupIndex++) {
									let columnIndex = gradesMap.get(gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].gradeName + "-" + gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].groups[_groupIndex].groupName)
									if (columnIndex !== undefined) {
										dataTableMap.set(rowIndex + "-" + columnIndex, { elective: electives[electiveIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[_gradeLevelIndex].levelName, grade: gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].gradeName, group: gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].groups[_groupIndex].groupName })
									}
								}
							}
						} else if (gradeLevels.gradeLevels[_gradeLevelIndex].isGradeLevelIntermediate) {
							for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[_gradeLevelIndex].grades.length; gradeIndex++) {
								if (gradeLevels.gradeLevels[_gradeLevelIndex].grades[gradeIndex].isGradeSelected) {
									for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[_gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
										let columnIndex = gradesMap.get(gradeLevels.gradeLevels[_gradeLevelIndex].grades[gradeIndex].gradeName + "-" + gradeLevels.gradeLevels[_gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName)
										if (columnIndex !== undefined) {
											dataTableMap.set(rowIndex + "-" + columnIndex, { elective: electives[electiveIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[_gradeLevelIndex].levelName, grade: gradeLevels.gradeLevels[_gradeLevelIndex].grades[gradeIndex].gradeName, group: gradeLevels.gradeLevels[_gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName })
										}
									}
								} else {
									for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[_gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
										if (gradeLevels.gradeLevels[_gradeLevelIndex].grades[gradeIndex].groups[groupIndex].isGroupSelected) {
											let columnIndex = gradesMap.get(gradeLevels.gradeLevels[_gradeLevelIndex].grades[gradeIndex].gradeName + "-" + gradeLevels.gradeLevels[_gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName)
											if (columnIndex !== undefined) {
												dataTableMap.set(rowIndex + "-" + columnIndex, { elective: electives[electiveIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[_gradeLevelIndex].levelName, grade: gradeLevels.gradeLevels[_gradeLevelIndex].grades[gradeIndex].gradeName, group: gradeLevels.gradeLevels[_gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName })
											}
										}
									}
								}
							}
						}

					}
				}
			} else {

				if (gradeLevels.isAllChecked) {
					// for (let [key, columnIndex] of gradesMap) {
					//   dataTableMap.set(rowIndex + "-" + columnIndex, { subject: subjects[i], isSelected: false, border: '' })
					// }
					for (let i = 0; i < gradeLevels.gradeLevels.length; i++) {
						for (let j = 0; j < gradeLevels.gradeLevels[i].grades.length; j++) {
							let columnIndex = gradesMap.get(gradeLevels.gradeLevels[i].grades[j].gradeName)
							if (columnIndex !== undefined) {
								dataTableMap.set(rowIndex + "-" + columnIndex, { elective: electives[electiveIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[i].levelName, grade: gradeLevels.gradeLevels[i].grades[j].gradeName })
							}
						}
					}
				} else if (gradeLevels.indeterminate) {
					for (let _gradeLevelIndex = 0; _gradeLevelIndex < gradeLevels.gradeLevels.length; _gradeLevelIndex++) {
						if (gradeLevels.gradeLevels[_gradeLevelIndex].isGradeLevelSelected) {
							for (let _gradeIndex = 0; _gradeIndex < gradeLevels.gradeLevels[_gradeLevelIndex].grades.length; _gradeIndex++) {
								let columnIndex = gradesMap.get(gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].gradeName)
								if (columnIndex !== undefined) {
									dataTableMap.set(rowIndex + "-" + columnIndex, { elective: electives[electiveIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[_gradeLevelIndex].levelName, grade: gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].gradeName })
								}
							}
						} else if (gradeLevels.gradeLevels[_gradeLevelIndex].isGradeLevelIntermediate) {
							for (let _gradeIndex = 0; _gradeIndex < gradeLevels.gradeLevels[_gradeLevelIndex].grades.length; _gradeIndex++) {
								if (gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].isGradeSelected) {
									for (let _groupIndex = 0; _groupIndex < gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].groups.length; _groupIndex++) {
										let columnIndex = gradesMap.get(gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].gradeName)
										if (columnIndex !== undefined) {
											dataTableMap.set(rowIndex + "-" + columnIndex, { elective: electives[electiveIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[_gradeLevelIndex].levelName, grade: gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].gradeName })
										}
									}
								} else {
									// for (let _groupIndex = 0; _groupIndex < gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].groups.length; _groupIndex++) {
									// 	if (gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].groups[_groupIndex].isGroupSelected) {
									// 		let columnIndex = gradesMap.get(gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].gradeName)
									// 		if (columnIndex !== undefined) {
									// 			//dataTableMap.set(rowIndex + "-" + columnIndex, { elective: electives[electiveIndex], isSelected: false, border: '', gradeLevel: gradeLevels.gradeLevels[_gradeLevelIndex].levelName, grade: gradeLevels.gradeLevels[_gradeLevelIndex].grades[_gradeIndex].gradeName })
									// 		}
									// 	}
									// }
								}
							}
						}

					}
				}
			}
		}

	}

	handleGradePickerOpen = () => {
		let weeklyCalendarObj = this.state.weeklyCalendar
		if (weeklyCalendarObj !== undefined) {
			let calendarGradeDetails = weeklyCalendarObj.gradeDetails;
			let subSetGradeLevel = gradePickerUtil.showSubsetOfGrades({ gradeLevels: this.state.masterGradeLevels }, calendarGradeDetails);
			let savedGradeLevel = gradePickerUtil.constructGradeLevelJSON(subSetGradeLevel, this.state.filter.gradeDetails);
			this.setState({
				openForFilterRules: true, gradeLevelForFilterRules: savedGradeLevel,
			});
		} else {
			toast(`weekly calendar gradeDetails illa.`)
		}
	};

	handleGradePickerClose = () => {
		this.setState({ isGradeDropDownClicked: false, openForFilterRules: false });
	};

	toggleChangeForGradePicker = () => {
		this.setState({ isGradeDropDownClicked: !this.state.isGradeDropDownClicked });
	}
	onClickOfSaveInGradePicker = async (gradeDetails) => {
		let weeklyCalendar = this.state.weeklyCalendar
		if (weeklyCalendar !== undefined) {
			let calendarGradeDetails = weeklyCalendar.gradeDetails
			if (calendarGradeDetails.allGrades === true) {
				let masterGradeLevels = this.props.activeSchool.school_master.gradeLevels
				if (masterGradeLevels.length === gradeDetails.gradeLevels.length) {
					gradeDetails = calendarGradeDetails
				}
			}
		}

		let filter = { ...this.state.filter }
		filter.gradeDetails = gradeDetails;
		let gradeString = gradePickerUtil.getGradesString(gradeDetails)
		this.handleGradePickerClose();
		let gradesMap = this.getGradesMap(this.state.masterGradeLevels, filter);
		let subjectsMap = this.getSubjectsMap(this.state.subjects);
		let electivesMap = this.getElectivesMap(this.state.electives)
		let gradeLevels = this.state.masterGradeLevels
		let subjectsAndElectivesMap = this.getSubjectsAndElectivesMap(this.state.subjects, this.state.electives, filter);
		let subjectsAndElectivesMapSize = subjectsAndElectivesMap.size;
		let dataTableMap = this.getDataTableMap(gradesMap, subjectsAndElectivesMap, electivesMap, this.state.subjects, this.state.electives, gradeLevels, filter);
		dataTableMap = this.getJointClassMap(dataTableMap, this.state.subjects, filter);
		dataTableMap = this.getAssignedDataMap(dataTableMap, this.state.subjects, filter);
		this.generateDataTableMap(dataTableMap, filter)
		let gradesMapSize = gradesMap.size;
		this.setState({
			gradeString: gradeString,
			filter: filter,
			gradesMap: gradesMap,
			subjectsMap: subjectsMap,
			dataTableMap: dataTableMap,
			gradesMapSize: gradesMapSize,
			subjectsAndElectivesMapSize: subjectsAndElectivesMapSize,
			subjectsAndElectivesMap: subjectsAndElectivesMap
		});
		// this.setState({ dataTableMap: dataTableMap })
	}

	handleShowSectionsFilter = () => {
		let filter = { ...this.state.filter }
		filter.showSections = !filter.showSections
		let gradesMap = this.getGradesMap(this.state.masterGradeLevels, filter);
		let subjectsMap = this.getSubjectsMap(this.state.subjects);
		let electivesMap = this.getElectivesMap(this.state.electives)
		let gradeLevels = this.state.masterGradeLevels
		let subjectsAndElectivesMap = this.getSubjectsAndElectivesMap(this.state.subjects, this.state.electives, filter);
		let subjectsAndElectivesMapSize = subjectsAndElectivesMap.size;
		let dataTableMap = this.getDataTableMap(gradesMap, subjectsAndElectivesMap, electivesMap, this.state.subjects, this.state.electives, gradeLevels, filter);

		let gradesMapSize = gradesMap.size;
		this.setState({
			filter: filter,
			gradesMap: gradesMap,
			subjectsMap: subjectsMap,
			dataTableMap: dataTableMap,
			gradesMapSize: gradesMapSize,
			subjectsAndElectivesMapSize: subjectsAndElectivesMapSize,
			subjectsAndElectivesMap: subjectsAndElectivesMap
		});
		dataTableMap = this.getJointClassMap(dataTableMap, this.state.subjects, filter);

		dataTableMap = this.getAssignedDataMap(dataTableMap, this.state.subjects, filter);
		this.generateDataTableMap(dataTableMap, filter);

	}

	handleShowAllSubjects = () => {
		let filter = { ...this.state.filter }
		filter.showAllSubjects = !filter.showAllSubjects;
		let gradesMap = this.getGradesMap(this.state.masterGradeLevels, filter);
		let subjectsMap = this.getSubjectsMap(this.state.subjects, filter);
		let electivesMap = this.getElectivesMap(this.state.electives)
		let subjectsAndElectivesMap = this.getSubjectsAndElectivesMap(this.state.subjects, this.state.electives, filter);
		let subjectsAndElectivesMapSize = subjectsAndElectivesMap.size;
		let gradeLevels = this.state.masterGradeLevels
		let gradesMapSize = gradesMap.size;
		let dataTableMap = this.getDataTableMap(gradesMap, subjectsAndElectivesMap, electivesMap, this.state.subjects, this.state.electives, gradeLevels, filter);
		dataTableMap = this.getJointClassMap(dataTableMap, this.state.subjects, filter);
		dataTableMap = this.getAssignedDataMap(dataTableMap, this.state.subjects, filter);
		this.generateDataTableMap(dataTableMap, filter);
		this.setState({
			filter: filter,
			gradesMap: gradesMap,
			subjectsMap: subjectsMap,
			dataTableMap: dataTableMap,
			gradesMapSize: gradesMapSize,
			subjectsAndElectivesMap: subjectsAndElectivesMap,
			subjectsAndElectivesMapSize: subjectsAndElectivesMapSize
		});
	}

	getJointClassMap = (dataTableMap, subjects, filter) => {
		let jointClasses = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses;
		if (jointClasses.length > 0) {
			for (let jointClassesIndex = 0; jointClassesIndex < jointClasses.length; jointClassesIndex++) {
				for (let jointClassesGradeIndex = 0; jointClassesGradeIndex < jointClasses[jointClassesIndex].gradeDetails.grades.length; jointClassesGradeIndex++) {
					if (jointClasses[jointClassesIndex].gradeDetails.grades[jointClassesGradeIndex].groups.length > 0) {
						for (let jointClassesGroupIndex = 0; jointClassesGroupIndex < jointClasses[jointClassesIndex].gradeDetails.grades[jointClassesGradeIndex].groups.length; jointClassesGroupIndex++) {
							for (let [key, value] of dataTableMap) {
								//let subject = lodashUtil.find(subjects,['_id', jointClasses[jointClassesIndex].subjectId])
								if (value.grade === jointClasses[jointClassesIndex].gradeDetails.grades[jointClassesGradeIndex].grade && value.group === jointClasses[jointClassesIndex].gradeDetails.grades[jointClassesGradeIndex].groups[jointClassesGroupIndex].groupCode) {
									if ((value.subject && value.subject._id == jointClasses[jointClassesIndex].subjectId) || (value.elective && value.elective._id == jointClasses[jointClassesIndex].electiveId)) {
										value.jointClass = jointClasses[jointClassesIndex];
										value.bgColor = jointClasses[jointClassesIndex].bgColor;
										dataTableMap.set(key, value)
									}
								} //else if(value.grade == jointClasses[jointClassesIndex].gradeDetails.grades[jointClassesGradeIndex].grade){
								//   value.jointClassId = jointClasses[jointClassesIndex]._id;
								//   value.bgColor = jointClasses[jointClassesIndex].bgColor;
								//   dataTableMap.set(key,value)
								// }
							}
						}
					}
				}
			}
		}
		return dataTableMap;
	}

	getAssignedDataMap = (dataTableMap, subjects, filter) => {
		let assignedData = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].assignedData;
		if (assignedData && assignedData.length > 0) {

			for (let [key, value] of dataTableMap) {
				let assignedDataForClass = lodashUtil.find(assignedData, function (o) {
					return o.grade === value.grade && o.group === value.group;
				});
				if (assignedDataForClass) {
					if (value.subject) {
						let assignedDataForClassSubject = lodashUtil.find(assignedDataForClass.subjects, function (o) {
							return o.code.toLowerCase() === value.subject.code.toLowerCase();
						});

						if (assignedDataForClassSubject) {
							value.assignedData = assignedDataForClassSubject;
							dataTableMap.set(key, value)
						}
					} else if (value.elective) {
						let assignedDataForClassElective = lodashUtil.find(assignedDataForClass.electives, function (o) {
							return o.name.toLowerCase() === value.elective.name.toLowerCase();
						});

						if (assignedDataForClassElective) {
							value.assignedData = assignedDataForClassElective;
							dataTableMap.set(key, value)
						}
					}


					/* if ((value.subject && value.subject._id == assignedData[assignedDataIndex].subjectId) || 
					(value.elective && value.elective._id == assignedData[assignedDataIndex].electiveId)) {
						value.jointClass = assignedData[assignedDataIndex];
						value.bgColor = assignedData[assignedDataIndex].bgColor;
						dataTableMap.set(key, value)
					} */
				}

			}


		}
		return dataTableMap;
	}

	// attaching the multiPeriods to the cells for the second time.
	getConstraintDetails = (dataTableMap, filter, constraintsArray, constraintName) => {
		if (constraintsArray.length > 0) {
			if (filter.showSections) {	// show sections is true take the groups and attach data to the cell
				for (let i = 0; i < constraintsArray.length; i++) {	//given a "constraints" array (inside schedule_const) get "one object" from the array.
					if (constraintsArray[i].gradeDetails.grades[0].groups.length !== 0) {
						let gradeDetails = constraintsArray[i].gradeDetails
						for (let j = 0; j < gradeDetails.grades.length; j++) {	// constraints one object's gradeDetails grade 
							let gradeName = gradeDetails.grades[j].grade;
							let groups = gradeDetails.grades[j].groups;
							// let groupsCount = groups.length;
							// let count = 0;

							for (let [key, value] of dataTableMap) { // data from its particular cell

								if ((value.subject && value.subject._id == constraintsArray[i].subjectId) || (value.elective && value.elective._id == constraintsArray[i].electiveId)) {

									if (value.grade === gradeName) {

										let isGroupPresent = lodashUtil.find(groups, ['groupCode', value.group]);
										if (isGroupPresent !== undefined) {
											value[constraintName] = constraintsArray[i];
											dataTableMap.set(key, value)
											// count++;
											// if (groupsCount === count) {
											break;
											// }
										}
									}
								}
							}
						}

					}
				}
			} else { // if show sections is false take only grades and attach data to the cell.

				for (let i = 0; i < constraintsArray.length; i++) {	//given a "constraints" array (inside schedule_const) get "one object" from the array.
					if (constraintsArray[i].gradeDetails.grades[0].groups.length === 0) {
						let gradeDetails = constraintsArray[i].gradeDetails
						let gradesCount = gradeDetails.grades.length;
						let count = 0;

						for (let [key, value] of dataTableMap) { // data from its particular cell
							if ((value.subject && value.subject._id == constraintsArray[i].subjectId) || (value.elective && value.elective._id == constraintsArray[i].electiveId)) {
								if (gradeDetails.grades[0].grade === value.grade) {
									value[constraintName] = constraintsArray[i];
									dataTableMap.set(key, value)
									count++;
									if (gradesCount === count) {
										break;
									}
								}
							}
						}
					} else {
						//adding this else clause to handle the display of totalPeriods contraint, 
						//when showSections is false and the total periods are different for different sections for grade show --
						if (constraintName === 'totalPeriod') {
							let gradeDetails = constraintsArray[i].gradeDetails
							let gradesCount = gradeDetails.grades.length;
							let count = 0;


							for (let [key, value] of dataTableMap) { // data from its particular cell
								if ((value.subject && value.subject._id == constraintsArray[i].subjectId) || (value.elective && value.elective._id == constraintsArray[i].electiveId)) {
									if (gradeDetails.grades[0].grade === value.grade) {
										let isUnique = true;
										let oldValue = -1;
										let allForThisGrade = constraintsArray.filter(element =>
											(element.gradeDetails.grades[0].grade === gradeDetails.grades[0].grade)
											&& (value.subject && value.subject._id == element.subjectId) || (value.elective && value.elective._id == element.electiveId)
										);
										allForThisGrade.forEach(element => {
											if (oldValue === -1) {
												oldValue = element.count;
											} else {
												if (element.count != oldValue) {
													isUnique = false;
												}
											}
										});
										//also check if all the groups/sections of this grade has data
										let thisGradeLevel = this.props.activeSchool.school_master.gradeLevels.filter(element =>
											element.levelName === gradeDetails.gradeLevels[0].level);

										let thisGradeGroups = thisGradeLevel && thisGradeLevel.length > 0 && thisGradeLevel[0].grades.filter(element =>
											element.gradeName === value.grade);
										if (thisGradeGroups && thisGradeGroups.length > 0 && thisGradeGroups[0].groups.length > allForThisGrade.length) {
											isUnique = false;
										}
										value[Constants.RULES_TOTAL_PERIOD_DATATABLE_SHOW_KEY] = isUnique ? oldValue : '--';
										dataTableMap.set(key, value)
										count++;
										if (gradesCount === count) {
											break;
										}
									}
								}
							}
						}
					}
				}
			}
		}

		return dataTableMap
	}
	verifyTimeTable = async (displayError) => {
		if (displayError) { this.props.viewErrors(displayError) }
		this.props.activeSchool.schedule_constraints[this.props.scheduleIndex].modifiedDate = new Date()
		this.props.activeSchool.schedule_constraints[this.props.scheduleIndex].enableGenerateTimeTable = false;	
		let scheduleConstraints = await this.props.verifyTimeTable(this.props.userInformation._id, this.props.userInformation.email, this.props.activeSchool, this.props.scheduleIndex, this.props.activeScheduleId)

	}
	generateTimeTable = async (displayError) => {
		if (displayError) { this.props.viewErrors(displayError) }
		await this.props.generateTimeTable(this.props.userInformation._id, this.props.userInformation.email, this.props.activeSchool, this.props.scheduleIndex)
		this.props.history.push("/")
	}

	getTotalPeriodsByGradeFromCalender = (gradeLevelName, gradeName, totalGroups) => {
		let periodsDetails = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].weeklyCalendar[0].periodsDetails;
		let count = 0;
		for (let pdIndex = 0; pdIndex < periodsDetails.length; pdIndex++) {
			for (let pIndex = 0; pIndex < periodsDetails[pdIndex].periods.length; pIndex++) {
				if (periodsDetails[pdIndex].periods[pIndex].typeOfPeriod === "period") {
					if (periodsDetails[pdIndex].periods[pIndex].gradeDetails.allGrades) {
						count++
					} else {
						for (let glIndex = 0; glIndex < periodsDetails[pdIndex].periods[pIndex].gradeDetails.gradeLevels.length; glIndex++) {
							if (periodsDetails[pdIndex].periods[pIndex].gradeDetails.gradeLevels[glIndex].level === gradeLevelName) {
								count++
							}
						}
						for (let gIndex = 0; gIndex < periodsDetails[pdIndex].periods[pIndex].gradeDetails.grades.length; gIndex++) {
							if (periodsDetails[pdIndex].periods[pIndex].gradeDetails.grades[gIndex].grade === gradeName) {
								count++
							}
						}
					}
				}
			}
		}
		if (totalGroups !== undefined && totalGroups > 0) {
			return count * totalGroups;
		}
		return count;
	}

	getTotalPeriodsByGradeFromRules = (gradeLevelName, gradeName, totalGroups) => {
		let totalPeriods = lodashUtil.filter(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].totalPeriods,
			function (o) {
				return o.gradeDetails.grades[0].grade === gradeName && o.gradeDetails.grades[0].groups.length > 0
			});
		let sumOfPeriodsInRules = totalPeriods.reduce(function (acc, obj) { return acc + obj.count; }, 0);
		let sumOfPeriodsInCalender = this.getTotalPeriodsByGradeFromCalender(gradeLevelName, gradeName, totalGroups)
		if (sumOfPeriodsInRules < sumOfPeriodsInCalender) {
			return { sumOfPeriodsInRules: sumOfPeriodsInRules, color: theme.colorPalatte.primary, sumOfPeriodsInCalender: sumOfPeriodsInCalender }
		} else if (sumOfPeriodsInRules > sumOfPeriodsInCalender) {
			return { sumOfPeriodsInRules: sumOfPeriodsInRules, color: "#b00707", sumOfPeriodsInCalender: sumOfPeriodsInCalender }
		} else {
			return { sumOfPeriodsInRules: sumOfPeriodsInRules, color: "#4BB543", sumOfPeriodsInCalender: sumOfPeriodsInCalender }
		}
	}
	getTotalPeriodsByGroupFromRules = (gradeLevelName, gradeName, groupName) => {
		
		let totalPeriods = lodashUtil.filter(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].totalPeriods,
			function (o) {
				return o.gradeDetails.grades[0].grade === gradeName && o.gradeDetails.grades[0].groups.length > 0 && o.gradeDetails.grades[0].groups[0].groupCode === groupName
			});
		let sumOfPeriodsInRules = totalPeriods.reduce(function (acc, obj) { return acc + obj.count; }, 0);
		let sumOfPeriodsInCalender = this.getTotalPeriodsByGradeFromCalender(gradeLevelName, gradeName, undefined)
		if (sumOfPeriodsInRules < sumOfPeriodsInCalender) {
			return { sumOfPeriodsInRules: sumOfPeriodsInRules, color: theme.colorPalatte.primary, sumOfPeriodsInCalender: sumOfPeriodsInCalender }
		} else if (sumOfPeriodsInRules > sumOfPeriodsInCalender) {
			return { sumOfPeriodsInRules: sumOfPeriodsInRules, color: "#b00707", sumOfPeriodsInCalender: sumOfPeriodsInCalender }
		} else {
			return { sumOfPeriodsInRules: sumOfPeriodsInRules, color: "#4BB543", sumOfPeriodsInCalender: sumOfPeriodsInCalender }
		}
	}
	showContextualHelp = (props, event) => {
		let content = props.contextualHelp["timetableRules"];
		if (content !== undefined) {
			props.toggleDrawer("right", true, content)(event)
		}
	}
	render() {
		return (<RulesComponent
			{...this.state}
			{...this.props}
			handleGradePickerOpen={this.handleGradePickerOpen}
			handleGradePickerClose={this.handleGradePickerClose}
			onClickOfSaveInGradePicker={this.onClickOfSaveInGradePicker}
			toggleChangeForGradePicker={this.toggleChangeForGradePicker}
			handleShowSectionsFilter={this.handleShowSectionsFilter}
			handleShowAllSubjects={this.handleShowAllSubjects}
			verifyTimeTableMethod={this.verifyTimeTable}
			generateTimeTableMethod={this.generateTimeTable}
			getTotalPeriodsByGradeFromRules={this.getTotalPeriodsByGradeFromRules}
			generateDataTableMap={this.generateDataTableMap}
			showContextualHelp={this.showContextualHelp}
			getTotalPeriodsByGroupFromRules={this.getTotalPeriodsByGroupFromRules}
		/>)

	}
}

const mapDispatchToProps = (dispatch) => ({
	verifyTimeTable: (ownerId, ownerEmail, activeSchool, scheduleIndex, activeScheduleId) => dispatch(SchoolInformationActions.verifyTimeTable(ownerId, ownerEmail, activeSchool, scheduleIndex, activeScheduleId)),
	generateTimeTable: (ownerId, ownerEmail, activeSchool, scheduleIndex) => dispatch(SchoolInformationActions.generateTimeTable(ownerId, ownerEmail, activeSchool, scheduleIndex)),

	setActiveSchool: (activeSchool) => dispatch(SchoolInformationActions.setActiveSchool(activeSchool)),
	editSchoolInformation: (ownerId, schoolId, school) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, school)),
	updateSchoolScheduleConstraints: (ownerId, schoolId, school, scheduleConstraintsIndex) => dispatch(SchoolInformationActions.updateSchoolScheduleConstraints(ownerId, schoolId, school, scheduleConstraintsIndex))
}
)
const mapStateToProps = (state, ownProps) => {
	return {
		activeSchool: state.schoolInformation.activeSchool,
		activeScheduleIndex: state.schoolInformation.activeScheduleIndex,
		activeScheduleId: state.schoolInformation.activeScheduleId,
		activeErrorItem: state.errorLog.activeErrorItem,
		updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress,
		userInformation: state.userProfile.userInformation
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(RulesContainer))
